import { useMemo, useState } from 'react'
import { PaginaNode } from '@gql/graphql'
import { useTrans } from 'hooks'
import { MenuItemType } from '@utils/types'
import { Search } from '@components/icons'
import { Chip, DownloadAccordion, WContainer } from '../../atoms'
import { DownloadList, GenericHero, Page, Prefooter } from 'components/organisms'
import styles from './AreaDownloadTemplate.module.sass'

interface Props {
  pagina?: PaginaNode
  items?: {
    key: string
    label: string
    type: 'brand' | 'default'
    children: MenuItemType[]
  }[]
}

const AreaDownloadTemplate = (props: Props) => {
  const { pagina = undefined, items = [] } = props

  const [selectedTab, setSelectedTab] = useState(items?.[0])
  const [searchValue, setSearchValue] = useState<string>('')
  const filteredResults = useMemo(
    () => items.find((x) => x.key === selectedTab?.key),
    [selectedTab]
  )

  const t = useTrans()

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <main>
        <GenericHero pagina={pagina} />
        {!!items?.length && (
          <WContainer>
            <div className={styles.content}>
              <div className={styles.chipsContainer}>
                {items.map((item) => (
                  <Chip
                    key={item.key}
                    label={item.label}
                    selected={selectedTab.key === item.key}
                    onClick={() => setSelectedTab(item)}
                  />
                ))}
              </div>
              <h3 className={styles.title}>{selectedTab?.label}</h3>
              <form className={styles.search}>
                <input
                  type="text"
                  name="seachBar"
                  value={searchValue}
                  placeholder={t('Cerca in {0}', [selectedTab.label])}
                  onChange={(e) => setSearchValue(e.target.value)}
                  className={styles.searchInput}
                />
                <button type="submit" className={styles.searchSubmit}>
                  <Search />
                </button>
              </form>
              {selectedTab.type === 'brand' ? (
                <div className={styles.accordionContainer}>
                  {filteredResults?.children?.length > 0 &&
                    filteredResults.children
                      .filter(
                        (brand) =>
                          !searchValue ||
                          brand.children?.filter(
                            (subI) =>
                              subI.children?.filter((cc) => cc.name.includes(searchValue))?.length
                          )?.length
                      )
                      .map((brand, index) => (
                        <DownloadAccordion key={index} label={brand.name} forceOpen={!!searchValue}>
                          <div className={styles.accordionBody}>
                            {brand.children.length > 0 &&
                              brand.children.map((subI) => (
                                <DownloadList
                                  context="accordion"
                                  key={subI.pk}
                                  item={subI}
                                  searchValue={searchValue}
                                />
                              ))}
                          </div>
                        </DownloadAccordion>
                      ))}
                </div>
              ) : (
                <div className={styles.downloadListContainer}>
                  {filteredResults?.children?.length > 0 &&
                    filteredResults.children.map((i) => (
                      <DownloadList key={i.pk} item={i} searchValue={searchValue} />
                    ))}
                </div>
              )}
            </div>
          </WContainer>
        )}
        <Prefooter />
      </main>
    </Page>
  )
}

export default AreaDownloadTemplate
